import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why I still haven't learned Haskell",
  "description": "",
  "published": "2012-06-18T00:00:00.000Z",
  "redirect_from": ["/blog/why-i-still-havent-learned-haskell/swizec/4663"],
  "categories": "Functional programming, Haskell, Implementations, Java, Languages, Programming, Tools, Uncategorized",
  "hero": "./img/wp-content-uploads-2009-03-light-at-end.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "600px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/6083e7f7ea1ed1306f70e71744533e6c/b4294/wp-content-uploads-2009-03-light-at-end.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.3677130044843%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'265\\'%20viewBox=\\'0%200%20400%20265\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20132v133h401V0H0v132m162-31l-6%202c-8%201-10%204-3%203l5%201h-3c-3-1-9%205-9%209%200%203-2%205-2%202%200-2%200-2-1-1%200%202-2%202-5%202s-2%202%202%205l4%202h-4c-4%200-4%200-4%203l-1%204c-1%201%200%202%201%203l2%203c0%202%200%202%201%201l2-2%202%201v2h1c2-2%202-2%203%200%201%203-1%2011-3%2011-1-1%200%207%202%209v13c1-1%202%200%203%201v6c-4%200-9%208-5%208l1-1c0-3%200-4%202-4h2l3%202c1%201%201%201-1%201s-2%200%200%201v2c-2%200-2%200-1%201%202%201%204%200%203-1l1-1%202%201-1%201v2l1%202h-3l2%202c2%202%203%203%202%204l2%203v3c2%201%202%202%201%202-1%201%200%202%203%202%206%201%2011%200%2011-2-1-1%201-5%202-5l1%202c-1%201-1%201%201%201h6c4%200%204%200%202%201-3%201-3%202-1%203l2%201c2-1%203%201%202%202h-3c-1-1-5%200-6%201l2%201h2l2%201v1l-3%201c-2-1-3%200-1%202h17l-3-1c-4%201-4-1-1-2s5%200%205%203c1%202%200%202-3%203l-7%202h-7l2%202c2%200%203%203%201%203v1c3%202%202%204-1%203-5%200-5%201-1%202l3%202%203-1h3l1%201v-1c0-1-1-2-3-2l-2-1h5c4%200%207-2%204-3h-2l-1-1v-1l2-1-2-1h-2l3-2%203-1h3l1-2h2v-1c-2-2-2-3-1-4h-4l-2-2-3-1h3l4-1c1%201%205-3%204-4l1-3c2-1%202-2%201-2l-4%203-2%201-1-1h-3v-3l3-1%203-2v-3l-1-1c-3%200-4-1-4-3%200-1%200-2%201-1l2-1-1-1v-1l2%201%201-1c1-2%201-2-1-1l-2-1%202-1c2%200%202%200%201-2-1-1-1-1%201-1h4l1-1c1-1%200-1-2-1l-3-1c1-1%201-2%205-2l1-1%201-1%204%205c2%204%203%205%203%202l-1-2-1-2c1-1%200-3-2-6-4-7-4-7%201-2l4%203v-3a631%20631%200%20011-26c0-4%200-4%205-1%204%202%205%202%205%200%201-1%201-1-1-1%200%201-1%201%200%200l-1-1c-1%200-6-5-6-7s3-2%205%200h1l2-1%201-1-1-1c-1%201-2-2-1-3h2l1-1-2-1c-2%200-3%201-3%202l-2%202c-3%201-3%200-3-4%200-3%200-4%202-2l1%201v-6l-1-1v-3c-1-2-1-2-1%200v3l-1%201c-1%200-3-5-2-6l-2-3v3c0%203%200%203-2%202l-2-1-4-2c-4-1-6-5-3-7l2-1%203-1%202-1v-1h-32c-8%201-10%200-9-1l-4-1c-3%200-3%200%200%201l3%201h-4l-5-2c-1-2-2-2-2-1m18%2012v4c1%202%200%203-3%206-5%204-11%2022-7%2018%202-2%204%200%204%203l1%203%202%205c0%204%202%207%202%204%200-2%202-3%202-1l2%204c3%204%204%200%205-10%200-14%200-14%202-13l1%202%201%202c3%203-1-12-5-16-3-3-4-7-3-7%202-1%200-5-2-5l-2%201m-26%20100l3%203h3l1-1%202%202%203%201%204%201-4%202-3%201%201%201v1h2l6%201c4%200%204%200%202-1l-3-3h3c1%200%202%200%201-1-2%200-3-2%200-2l2-1h-5l-5-1%204-1c4%200%204%200%203-1l-6-1h-3l-4-1h-5c-1-1-2-1-2%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6083e7f7ea1ed1306f70e71744533e6c/ca0a1/wp-content-uploads-2009-03-light-at-end.webp 223w", "/static/6083e7f7ea1ed1306f70e71744533e6c/75680/wp-content-uploads-2009-03-light-at-end.webp 445w", "/static/6083e7f7ea1ed1306f70e71744533e6c/e88ff/wp-content-uploads-2009-03-light-at-end.webp 600w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6083e7f7ea1ed1306f70e71744533e6c/853b2/wp-content-uploads-2009-03-light-at-end.jpg 223w", "/static/6083e7f7ea1ed1306f70e71744533e6c/0a4fe/wp-content-uploads-2009-03-light-at-end.jpg 445w", "/static/6083e7f7ea1ed1306f70e71744533e6c/b4294/wp-content-uploads-2009-03-light-at-end.jpg 600w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/6083e7f7ea1ed1306f70e71744533e6c/b4294/wp-content-uploads-2009-03-light-at-end.jpg",
                "alt": "Light at the end of the tunnel",
                "title": "Light at the end of the tunnel",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Light at the end of the tunnel`}</figcaption>{`
  `}</figure></p>
    <p>{`Short story: because I'm lazy.`}</p>
    <p>{`Long story is a bit more nuanced. It involves everything from how many hours there are in a day, how shiny the distractions are and having enough excuses to learn stuff.`}</p>
    <h2 {...{
      "id": "the-right-tool-for-the-job"
    }}>{`The right tool for the job`}</h2>
    <p>{`Possibly the biggest reason why I try out new technologies, get super excited, but then never learn them properly is the `}<em parentName="p">{`Use The Right Tool For The Job`}</em>{` mantra I've lived by ever since I stopped being a teenager and became bored of religious wars.`}</p>
    <p>{`At the end of the day, the client doesn't really care what technology you use, your users don't care about the technology either. They care about a working product that is maintainable, expandable and gives them a good `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Price/performance_ratio",
        "title": "Price/performance ratio"
      }}>{`price/performance ratio`}</a>{`.`}</p>
    <p>{`Now look at my life:`}</p>
    <ul>
      <li parentName="ul"><em parentName="li">{`Hey, can you make us a complex business-like website on `}<a parentName="em" {...{
            "href": "http://en.wikipedia.org/wiki/MySQL",
            "title": "MySQL"
          }}>{`MySQL`}</a>{`?`}</em>{` - Sure! -> django`}</li>
      <li parentName="ul"><em parentName="li">{`Hey, we need a glue layer between a bunch of services!`}</em>{` - Awesome! -> node.js`}</li>
      <li parentName="ul"><em parentName="li">{`Hey, I need a script to munge this data into that data.`}</em>{` - Hooray! -> python`}</li>
      <li parentName="ul"><em parentName="li">{`Hey, can you do X with websites for us?`}</em>{` - Yep! Finally something algorithmic, I can use `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Haskell_%28programming_language%29",
          "title": "Haskell (programming language)"
        }}>{`Haskell`}</a>{` `}{`\\`}{`o/`}</li>
    </ul>
    <p>{`Oh wait ... except I can't use Haskell.`}</p>
    <p>{`I'm charging you decent money for this, and I'm not really productive in Haskell yet. I can make some cool things with it, but it takes twice or thrice as long as using tools I'm familiar with. Of `}<em parentName="p">{`course`}</em>{` you don't want to spend that kind of money to fund my pet learning subject.`}</p>
    <p>{`For no obvious gain of course.`}</p>
    <p>{`I could just as easily do it in some other language. Except it would be cheaper to create, easier for you to maintain and I'd spend more time on the problem than battling an unknown tool. `}<em parentName="p">{`But it wouldn't be as cool!`}</em></p>
    <p>{`Yeah ... oh and what's that? The best tool for the job happens to be a library that only works in Java? Great.`}</p>
    <p>{`And the vicious cycle just keeps repeating itself.`}</p>
    <p>{`Because I never know enough Haskell, Haskell never becomes the right tool for the job. There would have to be a `}<em parentName="p">{`very very good`}</em>{` reason that goes beyond "I love Haskell! It is the coolest language since forever!" to make me use Haskell on a paid-for project.`}</p>
    <h2 {...{
      "id": "time"
    }}>{`Time`}</h2>
    <p>{`Right, but I could just learn Haskell in my own time couldn't I? Then I'd know it well enough and suddenly it would be the right tool for the job and everyone would live happily ever after.`}</p>
    <p>{`Well, no.`}</p>
    <p>{`I've tried that:`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "http://swizec.com/blog/learning-me-a-haskell/swizec/3272"
        }}>{`Learning me a Haskell`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "http://swizec.com/blog/sabbatical-week-day-3-raining-datatypes/swizec/3293"
        }}>{`Raining datatypes`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "http://swizec.com/blog/a-message-from-your-future-self/swizec/3377"
        }}>{`A message from your future self`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "http://swizec.com/blog/collatz-haskell-and-memoization/swizec/3382"
        }}>{`Collatz, Haskell and memoization`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "http://swizec.com/blog/this-haskell-is-wrong-why/swizec/3489"
        }}>{`This Haskell is wrong, why?`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "http://swizec.com/blog/lychrel-numbers/swizec/3559"
        }}>{`Lychrel numbers`}</a></li>
    </ol>
    <p>{`Certainly not a lack of trying to learn Haskell. And I've learned a lot, don't get me wrong. It is most certainly my favourite language for implementing algorithms.`}</p>
    <p>{`But at the same time, I still haven't fully figured out monads and doing IO or anything actually too much useful ... it just doesn't come together.`}</p>
    <p>{`I mean, there's so many things to learn. So many things to do. There isn't enough time in the day to work on everything and learn everything that I want and love and find interesting.`}</p>
    <p>{`As unfortunate as it may be, `}<em parentName="p">{`Solving The Problem`}</em>{` mostly comes higher on my list of priorities than`}<em parentName="p">{` Learn This Cool New Way Of Solving The Problem`}</em>{`.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/3208258/memoization-in-haskell"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/94679149_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/3208258/memoization-in-haskell"
        }}>{`Memoization in Haskell?`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://justtesting.org/gpu-accelerated-array-computations-in-haskell"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/88781041_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://justtesting.org/gpu-accelerated-array-computations-in-haskell"
        }}>{`GPU accelerated arrays for Haskell`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.free-variable.org/2012/05/an-intro-to-haskell-for-ruby-programmers/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_00_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.free-variable.org/2012/05/an-intro-to-haskell-for-ruby-programmers/"
        }}>{`An Intro to Haskell for Ruby Developers`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://slidetocode.com/2012/04/09/why-i-prefer-scheme-to-haskell/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_08_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://slidetocode.com/2012/04/09/why-i-prefer-scheme-to-haskell/"
        }}>{`Why I prefer Scheme to Haskell`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.i-programmer.info/professional-programmer/i-programmer/3892-the-functional-view-of-the-new-languages.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_11_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.i-programmer.info/professional-programmer/i-programmer/3892-the-functional-view-of-the-new-languages.html"
        }}>{`The Functional View of the New Languages`}</a></li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=b8c535c5-2cdf-47f7-8371-444768f084df",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      